import {BasicScenario} from '../../framework/parameters/BasicScenario';

export class EntityModificationScenario extends BasicScenario {}

